import React, { useState, useEffect, useRef } from 'react';
import { Box } from "@mui/material";
import LmsKitLabel from "../../components/features/LmsKitLabel";
import { getPatientDetailsById } from "../../slices/QRCode";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { QRCodeCanvas } from 'qrcode.react';
import { useReactToPrint } from 'react-to-print';
import leftLogo from "../../assets/images/logos/LmsLogo1.png";
import { hasAuthority } from '../../../utils/authorities';
import { setSlugs } from '../../slices/help';
import { dateFormater } from '../../utils/common/utils';
import ProgressTracker from '../../components/common/ProgressTracker';
import { fetchV2V, selectAllInitialSteps, selectCurrentCycle } from '../../slices/common';
import ChatModule from '../Chat';
import { addPatientList, addPhaseList } from '../../slices/chat';
import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb";
import { urlToBackWithoutState } from "../../../utilites/Common";
// import rightLogo from "../../assets/images/logos/LmsLogo2.png";
import {capitalizeWords,convertToUpperCase} from "../../../utils/utils"
const GenerateQr = () => {

  const LoginData = useSelector((state) => state.loginData);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [BreadCrumbData] = useState(() =>
    urlToBackWithoutState(location.pathname, location?.state, undefined, navigate)
  );
  const [patientInfo, setPatientInfo] = useState({});
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
  const [printPatientInfo, setPrintPatientInfo] = useState({});
  const [bagCount, setBagCount] = useState(0);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [printCount, setPrintCount] = useState(null);
  const [printSingleBag, setPrintSingleBag] = useState(null);
  const qrRef = useRef(null);
  const contentRef = useRef(null);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const currentCycle = useSelector(selectCurrentCycle)
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const [ids, setIds] = useState(id)
  const [phaseType, setPhaseType] = useState('');

  const isCommercial = phaseType === "Commercial";
  const isTrial = phaseType === "Trial";
  const phaseLabels = {
    patient: isCommercial ? "Patient " : "Subject ",
    hospital: isCommercial ? "Hospital " : "Site ",
    investigator: isCommercial ? "HCP" : "Principal Investigator",
  };
  const reactToPrintFn = useReactToPrint({
    content: () => contentRef.current,
    onBeforeGetContent: async () => {
      await fetchPatientInfo();
    }
  });

    useEffect(() => {
      if(ids){
    fetchPatientInfo(ids);
    setIds('')
      }
  }, [ids]);
  
  useEffect(() => {
    if(!ids)
      fetchPatientInfo()
  },[currentCycle?.product_manufacturing_id])

  const fetchPatientInfo = async (id = currentCycle?.qr_code_generation_id) => {
    try {
      if(!id) return
      const patientDetailsResponse = await dispatch(getPatientDetailsById({id:id,prodmfg:currentCycle?.product_manufacturing_id})).unwrap();
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const isBagCount = patientDetailsResponse?.data?.number_of_bags;
      setBagCount(isBagCount || 0);
      setPhaseType(patientDetailsResponse?.data?.phase_type || '');

      if (patientDetails) {
        const patientBasicInfo = {
          patientName: patientDetails?.name || "-",
          phase_type: patientDetailsResponse?.data?.phase_type,
          patientInitials: patientDetails?.patient_initials,
          patientId: patientDetails?.patient_id || "-",
          immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
          subject_id: patientDetails?.subject_id || patientDetails?.id,
          product_id:patientDetailsResponse?.data?.product_id,
          phase_id:patientDetails?.phase_id,
          id: patientDetails?.id,
        };
        const patientMedicalRecord = {
          [`${phaseLabels.patient}Body Weight`]: `${patientDetails?.body_weight} kg` || "-",
          "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
          "Date of Birth": patientDetails?.dob ? dateFormater(patientDetails.dob) : "-",
         [`${phaseLabels.hospital}Name`]: patientDetails?.hospital || "-",
           [`${phaseLabels.hospital}Patient ID`]: patientDetailsResponse?.data?.hospital_patient_id || "-",
          "Ship & Store": "2-8 degree celsius",
         "Total no Bags": isBagCount || 0,
          "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
      
        };
        setPatientInfo(patientBasicInfo);
        setPatientMedicalInfo(patientMedicalRecord);
        setPrintPatientInfo(patientDetailsResponse?.data)
        // Generate QR code after a small delay to ensure it's rendered
        setTimeout(() => {
          const canvas = qrRef.current?.querySelector('canvas');
          if (canvas) {
            const dataUrl = canvas.toDataURL('image/png');
            setQrCodeDataUrl(dataUrl);
          }
        }, 300);
      }
      return true;
    } catch (error) {
      console.error("Error fetching patient info:", error);
      return false;
    }
  };

  const handlePrint = async (value) => {
    if (value?.bag_no) {
      setPrintCount(1)
      setPrintSingleBag(value?.bag_no)
    } else {
      setPrintCount(value?.bags)
      setPrintSingleBag(null)
    }
    reactToPrintFn();
  };

  useEffect(() => {
   if (currentCycle) {
      setPatientMedicalInfo((prev) => ({
        ...prev,
        "Total no Bags": currentCycle?.no_of_bags || 0,
        "Batch ID": currentCycle?.batch_no
      }));
    }
  }, [currentCycle]);

  const PrintContent = React.forwardRef((props, ref) => {
    const initials = patientInfo?.patientName
      ? patientInfo.patientName.split(' ').map(n => n[0]).join('').toUpperCase()
      : '';

    return (
      <div ref={ref} className="font-sans">
        {Array.from({ length: printCount }).map((_, index) => (
          <div
            key={index}
            style={{
              width: '14.25cm',
              height: '14.25cm',
              border: '1px solid #000',
              boxSizing: 'border-box',
              pageBreakAfter: 'always',
              // pageBreakInside: 'avoid',
              padding: '0.5cm',
              fontSize: '10px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {/* Header */}
            <div className="text-center">
              <div className="flex justify-between items-start mb-1">
                <div className="text-lg font-bold">Rx</div>
                <div className="text-[1.5rem] font-bold">Leukaphersis Starting Material</div>

                {/* <div className="text-[1.7rem] font-bold">actalycabtagene autoleucel</div> */}
                <div className="text-base text-lg mt-2">
                  <span className="font-light">Nex</span><span className="font-bold">CAR19</span><sup>™</sup>
                </div>
              </div>
              <div className="flex justify-between text-[0.7rem] px-1">
                <div className="text-center">
                  <div>Genetically modified</div>
                  <div>Human T cells</div>
                </div>
                <div className="text-center">
                  <div>Cell Suspension for IV infusion</div>
                  <div>For autologous use only</div>
                </div>
                <div className="text-right flex items-end gap-1 text-lg">
                  <img src={leftLogo} width={30} height={30} alt='imunoact360-logo' />
                  <span >ImmunoACT</span>
                </div>
              </div>
            </div>

            {/* Caution */}
            {/* <div className='flex justify-between gap-5 items-start mb-1'>
              <div className="flex justify-between items-center text-[0.7rem] bg-red-700  font-bold px-1 py-0.5 mt-1">
                Caution: To be provided on the prescription of a specialist/medical oncologist for the treatment of stated indication
              </div>
              <div>
                <div>
                  <img src={rightLogo} width={50} height={50} alt='right-logo' />
                </div>
              </div>
            </div> */}

            {/* Composition */}
            <div className="text-[0.7rem]  space-y-0.5 leading-tight">
              {/* <div><span className="font-bold">Dosage:</span> see product information sheet</div>
              <div>
                <span className="font-bold">Composition:</span> 100ml of cryopreserved cell suspension contains <span>1x10<sup>8</sup>-2x10<sup>9</sup></span> anti-CD19 CAR-T cells in 5% DMSO, 6% pentastarch, 3.4% HSA, and 1000 IU Heparin in Plasma-Lyte A.
              </div> */}
              <div className="font-bold">Verify Patient ID below</div>
            </div>

            {/* Patient Info */}
            <div className="border-2 border-black p-2 text-[0.7rem] flex justify-between items-start space-x-1">
              <div className="space-y-0.5">
                {!isTrial && (
                  <p><span className="font-bold">{phaseLabels.patient} Name : </span> <span className='font-semibold'>{printPatientInfo?.patient_information?.name}</span></p>
                )}
                <p><span className="font-bold">{phaseLabels.patient} Initials : </span><span className='font-semibold'>{convertToUpperCase(printPatientInfo?.patient_information?.patient_initials || initials)}</span> </p>
                <p><span className="font-bold">{phaseLabels.patient} body weight : </span><span className='font-semibold'>{printPatientInfo?.patient_information?.body_weight} kg</span> </p>
                <p><span className="font-bold">Disease Indication: </span> <span className='font-semibold'>{printPatientInfo?.patient_information?.disease}</span></p>
                <p><span className="font-bold">Date of Birth : </span><span className='font-semibold'>{patientMedicalInfo["Date of Birth"]}</span></p>
                <p><span className="font-bold">{phaseLabels.hospital} name : </span> <span className='font-semibold'>{printPatientInfo?.patient_information?.hospital}</span></p>
                <p><span className="font-bold">{phaseLabels.hospital} Patient ID : </span> <span className='font-semibold'>{patientInfo?.patientId}</span></p>
                <p><span className="font-bold">ImmunoACT Patient ID : </span> <span className='font-semibold'>{printPatientInfo?.patient_information?.immunoact_patient_id}</span></p>
                {/* <p><span className="font-bold">Patient ID : </span> <span className='font-semibold'>{printPatientInfo?.patient_information?.patientId}</span></p> */}
                <p><span className="font-bold">Ship and Store at {patientMedicalInfo["Ship & Store"]}</span></p>
                {/* <p><span className="font-bold">Mfg Date : </span><span className='font-semibold'>--</span> </p> */}
                {/* <p><span className="font-bold">Exp Date : </span> <span className='font-semibold'>--</span></p> */}
                {/* <p><span className="font-bold">Batch No : </span><span className='font-semibold'>{printPatientInfo?.batch_no}</span> </p> */}
                <p><span className="font-bold">Bag No : </span><span className='font-semibold'>
                  {printSingleBag ? printSingleBag : bagCount + index + 1}
                </span> </p>
              </div>
              <div className="ml-2 w-[80px] h-[80px]">
                {qrCodeDataUrl && (
                  <img src={qrCodeDataUrl} alt="QR Code" className="w-full h-full" />
                )}
              </div>
            </div>

            {/* Footer Instructions */}
            <div className="flex justify-between  items-start text-[0.7rem] leading-tight pt-1">
              <div className="space-y-0.5 w-1/2">
                <p><span className="font-bold">Dispense with prescribing information</span></p>
                <p className="font-bold">DO NOT USE LEUKOCYTE DEPLETING FILTER</p>
                <p className="font-bold">DO NOT IRRADIATE</p>
                <p>Not evaluated for infectious substances</p>
                <p className="font-bold">Confirm Patient ID prior to infusion</p>
                <p className="font-bold">Thaw at 36–38°C, mix gently, use within 2 hrs</p>
              </div>
              <div className="text-left w-1/2 pl-2">
                <p className="font-bold">Manufactured by:</p>
                <p>Immunoadoptive Cell Therapy Pvt. Ltd.</p>
                <p>1st Floor, Plot No. R-977, TTC Indl. Area,</p>
                <p>MIDC, Rabale, Navi Mumbai - 400 701</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  });

  const getTimeLine = async () => {
    const patientId = printPatientInfo?.patient_information?.id
    try {
      await dispatch(fetchV2V({ portal_type: 2, patient_id: patientId })).unwrap();
    }
    catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (printPatientInfo?.patient_information?.id) {
      getTimeLine()
    }
  }, [printPatientInfo?.patient_information?.id])


  useEffect(() => {
    if (hasAuthority(["qr-code-generation-print-qr"], bmr_permissions)) {
      dispatch(setSlugs(["print-reprint-lsm-qr"]));
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, []);

  ////////// phase and pantient List for chat bot ///////////

  useEffect(() => {
    const phaseList = [{ value: printPatientInfo?.patient_information?.phase_id, label: `${printPatientInfo?.phase_name} (${printPatientInfo?.product_name})`, patient_id: printPatientInfo?.patient_information?.id }]
    const patientList = [{ value: printPatientInfo?.patient_information?.id, label: `${printPatientInfo?.patient_information?.name}`, phase_id: printPatientInfo?.patient_information?.phase_id }]
    dispatch(addPatientList(patientList))
    dispatch(addPhaseList(phaseList))
  }, [printPatientInfo])
  
  ////////////////////////////////////////////////////////////
  return (
    <Box className="mt-4 ml-3 mr-3 mainDiv">
      <BreadCrumb BreadCrumbsListing={BreadCrumbData} />
      <div style={{ display: 'none' }} ref={qrRef}>
        <QRCodeCanvas value={`${baseUrl}/lsm/qr/${id}`} size={120} />
      </div>
      <LmsKitLabel
        screenType='none'
        patientInfo={patientInfo}
        patientMedicalInfo={patientMedicalInfo}
        qrCodeId={id}
        bagCount={bagCount}
        handlePrint={handlePrint}
        getTimeLine={getTimeLine}
      />
      {allInitialSteps?.length > 0 &&
        <Box container className=" pb-3 mainDiv">
          <ProgressTracker steps={allInitialSteps} patient_id={printPatientInfo?.patient_information?.id} buttonPop={['']} />
        </Box>}
      <div style={{ display: "none" }}>
        <PrintContent ref={contentRef} />
      </div>
      
        <ChatModule />
         </Box>
  );
};

export default GenerateQr;